"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    useSWR: true,
    useSWRMutation: true
};
Object.defineProperty(exports, "useSWR", {
    enumerable: true,
    get: function get() {
        return _swr.default;
    }
});
Object.defineProperty(exports, "useSWRMutation", {
    enumerable: true,
    get: function get() {
        return _mutation.default;
    }
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _constants[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _constants[key];
        }
    });
});
var _hooks = require("./hooks");
Object.keys(_hooks).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _hooks[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _hooks[key];
        }
    });
});
var _middleware = require("./middleware");
Object.keys(_middleware).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _middleware[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _middleware[key];
        }
    });
});
var _types = require("./types");
Object.keys(_types).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _types[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _types[key];
        }
    });
});
var _utils = require("./utils");
Object.keys(_utils).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _utils[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _utils[key];
        }
    });
});
var _gql = require("./gql");
Object.keys(_gql).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _gql[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _gql[key];
        }
    });
});
var _swr = _interopRequireWildcard(require("swr"));
Object.keys(_swr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _swr[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _swr[key];
        }
    });
});
var _mutation = _interopRequireDefault(require("swr/mutation"));
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
} //# sourceMappingURL=index.js.map
